// Modified from: https://github.com/Heydon/inclusive-menu-button/blob/master/inclusive-menu-button.js

// todo, make sure this is a valid test for non-mouse devices.
function supportsMouseEnterLeave() {
  const div = document.createElement('div');
  return 'onmouseenter' in div && 'onmouseleave' in div;
}

/**
 * Class representing a menu button that controls the visibility of a menu.
 */
export default class MenuButton {
  constructor(button, options = {}) {
    this.settings = {
      menuItemsSelector: 'a',
      activeClass: 'is-active',
      isMobile: false,
    };

    Object.keys(options).forEach((setting) => {
      this.settings[setting] = options[setting];
    });

    this.button = button;
    this.container = this.button.parentNode;
    this.menuId = this.button.getAttribute('data-opens-menu');
    this.menu = document.getElementById(this.menuId);
    this.menuHidden = true;
    this.menuItems = this.menu.querySelectorAll(this.settings.menuItemsSelector);
    this.menuItemsLength = this.menuItems.length;

    // eslint-disable-next-line prefer-destructuring
    this.firstItem = this.menuItems[0];
    // eslint-disable-next-line prefer-destructuring
    this.lastItem = this.menuItems[this.menuItemsLength - 1];

    this.supportsMouseEnterLeave = supportsMouseEnterLeave();

    // bind menu items to keydown event
    this.menuItems.forEach((menuItem, index) => {
      menuItem.addEventListener('keydown', (e) => {
        // Down
        if (e.keyCode === 40) {
          e.preventDefault();
          this.focusNext(index, 0);
        }

        // Up
        if (e.keyCode === 38) {
          e.preventDefault();
          this.focusNext(index, this.menuItemsLength - 1);
        }

        // Escape or tab
        if (e.keyCode === 27 || e.keyCode === 9) {
          this.toggle();
        }

        // Escape
        if (e.keyCode === 27) {
          e.preventDefault();
          this.button.focus();
        }
      });
    });

    // check if broswer supports mouseenter
    if (this.supportsMouseEnterLeave) {
      this.container.addEventListener('mouseenter', this.open.bind(this));
      this.container.addEventListener('mouseleave', this.close.bind(this));
    }

    this.button.addEventListener('click', this.toggle.bind(this));

    this.button.addEventListener('keydown', (e) => {
      if (e.keyCode === 40) {
        e.preventDefault();
        if (this.menuHidden) {
          this.open();
        } else {
          this.firstItem.focus();
        }
      }

      if (e.keyCode === 38) {
        this.close();
      }
    });
  }

  focusNext(currentItemIndex, startItemIndex) {
    const { menuItems } = this;
    const goingDown = startItemIndex === 0;

    function move(elemIndex) {
      return (goingDown ? menuItems[elemIndex + 1] : menuItems[elemIndex - 1]) || menuItems[startItemIndex];
    }

    const nextItem = move(currentItemIndex);

    nextItem.focus();
  }

  open() {
    this.button.setAttribute('aria-expanded', true);
    this.menuHidden = false;
    this.menu.classList.add(this.settings.activeClass);

    this.outsideClick = function (e) {
      if (!this.menu.contains(e.target) && !this.button.contains(e.target)) {
        this.close();
      }
    };

    document.addEventListener('click', this.outsideClick.bind(this));

    return this;
  }

  close() {
    this.button.setAttribute('aria-expanded', false);
    this.menuHidden = true;
    this.menu.classList.remove(this.settings.activeClass);

    // remove click event
    document.removeEventListener('click', this.outsideClick);

    return this;
  }

  toggle() {
    const expanded = this.button.getAttribute('aria-expanded') === 'true';
    return expanded ? this.close() : this.open();
  }
}
